import { lazy, StrictMode, Suspense } from "react"
import { createRoot, hydrateRoot } from "react-dom/client"

import App from "@/apps/EntryApp"
import { AppProviders } from "@/lib/app-providers"
import "@/index.css"

const AgentationToolbar = import.meta.env.DEV
  ? lazy(() =>
      import("agentation").then((module) => ({
        default: module.Agentation,
      }))
    )
  : null

const container = document.getElementById("root")!
const tree = (
  <AppProviders>
    <StrictMode>
      <App />
      {AgentationToolbar && (
        <Suspense fallback={null}>
          <AgentationToolbar />
        </Suspense>
      )}
    </StrictMode>
  </AppProviders>
)

// O index.html do Quantum+ pode trazer o app shell do login já em #root
// (ver vite.config.ts). Nesse caso o React hidrata a marcação existente, sem
// repintar; nas demais rotas o container está vazio e o render é normal.
if (container.firstElementChild) {
  hydrateRoot(container, tree)
} else {
  createRoot(container).render(tree)
}
